import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

const { ROUTE_CONSTANTS } = require(`../shared/constants/Route`);
const { LoginScreen, SignupScreen, TermsOfUse } = require(`../Screens`);

const AuthRouter = (props) => {
  return (
    <React.Fragment>
      <Switch>
        <Route path={ROUTE_CONSTANTS.LOGIN} component={LoginScreen}/>
        <Route path={ROUTE_CONSTANTS.SIGNUP} component={SignupScreen}/>
        <Route exact path={ROUTE_CONSTANTS.TERMS_OF_USE} component={TermsOfUse}/>
        <Redirect to={ROUTE_CONSTANTS.LOGIN}/>
      </Switch>
    </React.Fragment>
  );
};

export default AuthRouter;
